/**
 * API layer quản trị viên — CRUD tài khoản admin nội bộ.
 */
import { apiClient } from '../../../../shared/services/apiClient';
import { API_ROUTES } from '../../../../shared/constants/apiRoutes';

/** Các hàm gọi API admin users. */
export const adminUserApi = {
  /** Danh sách tài khoản admin. */
  getAdminUsers: () => apiClient.get(API_ROUTES.adminUsers),
  /** Tạo admin mới. */
  createAdminUser: (adminPayload) => apiClient.post(API_ROUTES.adminUsers, adminPayload),
  /** Đặt lại mật khẩu admin. */
  resetAdminPassword: (adminId, password) =>
    apiClient.put(API_ROUTES.adminUserPassword(adminId), { password }),
};
